import { dispatch, mutate, receive } from "./api.service";

const base = "/investor";

export const registerInvestor = (data) => dispatch(data, `${base}/register`);
export const updateInvestorProfile = (data) => mutate(data, `${base}`);
export const getAllInvestors = () => receive(`/investors/accepted`);
